import { Stack, Skeleton, useTheme } from "@mui/material";

const PropertyCardSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack
      direction="column"
      padding={theme.nawy.spacing.md}
      gap={theme.nawy.spacing.md}
      bgcolor="#F9F9F9"
      borderRadius={theme.nawy.radius["2xl"]}
    >
      <Stack direction="column" gap={theme.nawy.spacing.xs}>
        <Skeleton
          variant="text"
          width="70%"
          height={24}
          sx={{ borderRadius: theme.nawy.radius.lg }}
        />
        <Skeleton
          variant="text"
          width="50%"
          height={18}
          sx={{ borderRadius: theme.nawy.radius.lg }}
        />
      </Stack>

      <Stack direction="column" gap={theme.nawy.spacing.xxs}>
        {[...Array(3)].map((_, i) => (
          <Stack key={i} direction="row" gap={theme.nawy.spacing.xs}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton
              variant="text"
              width="30%"
              height={20}
              sx={{ borderRadius: theme.nawy.radius.lg }}
            />
          </Stack>
        ))}
      </Stack>

      <Skeleton
        variant="text"
        width="40%"
        height={20}
        sx={{ borderRadius: theme.nawy.radius.lg }}
      />
    </Stack>
  );
};

export default PropertyCardSkeleton;
